import { StackScreenProps } from "@react-navigation/stack";
import {
  Card,
  FlatActionList,
  Page,
  Stack,
  TextButton,
} from "@towersystems/roam-common-native";
import { Switch } from "react-native";
import { View } from "react-native-ui-lib";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { moneyToFormattedString } from "../../../../utilities/money";

export interface ShiftSettingsRootScreenProps
  extends StackScreenProps<SettingsRootParamList, "ShiftSettingsRootScreen"> {}

export const ShiftSettingsRootScreen = ({
  navigation,
}: ShiftSettingsRootScreenProps) => {
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const {
    automaticOpenTerminalClosure,
    showExpectedClosureCounts,
    automaticallyEmailTerminalClosureSummary,
    terminalClosureSendToAddress,
  } = globalSettings;

  return (
    <Page title="Shift Settings">
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              {
                key: "automaticOpenTerminalClosure",
                title: "Automatically Open Shift",
                subTitle:
                  "A new shift will be opened when a terminal is closed",
                componentRight: () => {
                  return (
                    <View>
                      <Switch
                        value={automaticOpenTerminalClosure}
                        onValueChange={() => {
                          updateGlobalSettings({
                            automaticOpenTerminalClosure:
                              !automaticOpenTerminalClosure,
                          }).catch((err) => console.log(err));
                        }}
                      />
                    </View>
                  );
                },
              },
              {
                key: "showExpectedClosureCounts",
                title: "Show Expected Count",
                subTitle: "Show expected count on shift closure screen",
                componentRight: () => {
                  return (
                    <View>
                      <Switch
                        value={showExpectedClosureCounts}
                        onValueChange={() => {
                          updateGlobalSettings({
                            showExpectedClosureCounts:
                              !showExpectedClosureCounts,
                          }).catch((err) => console.log(err));
                        }}
                      />
                    </View>
                  );
                },
              },
              {
                key: "defaultTerminalClosureFloat",
                title: "Default Float",
                subTitle:
                  "The default float amount for a new shift if one is not specified",
                componentRight: () => {
                  return (
                    <View>
                      <TextButton
                        onPress={() =>
                          navigation.navigate("EditShiftClosureFloatScreen")
                        }
                      >
                        {moneyToFormattedString(
                          globalSettings.defaultTerminalClosureFloat.toString()
                        )}
                      </TextButton>
                    </View>
                  );
                },
              },
            ]}
          />
        </Card>

        <Card>
          <FlatActionList
            items={[
              {
                key: "automaticallyEmailTerminalClosureSummary",
                title: "Automatically Email End of Shift Summary",
                subTitle:
                  "A email summary will be emailed to the destination email when a shift is closed",
                componentRight: () => {
                  return (
                    <View>
                      <Switch
                        value={automaticallyEmailTerminalClosureSummary}
                        onValueChange={() => {
                          updateGlobalSettings({
                            automaticallyEmailTerminalClosureSummary:
                              !automaticallyEmailTerminalClosureSummary,
                          }).catch((err) => console.log(err));
                        }}
                      />
                    </View>
                  );
                },
              },
              {
                key: "terminalClosureSendToAddress",
                title: "End of Shift Destination Email",
                componentRight: () => {
                  return (
                    <TextButton
                      onPress={() =>
                        navigation.navigate(
                          "EditEndOfShiftDestinationEmailScreen"
                        )
                      }
                    >
                      {terminalClosureSendToAddress || "Set Destination Email"}
                    </TextButton>
                  );
                },
              },
            ]}
          ></FlatActionList>
        </Card>
      </Stack>
    </Page>
  );
};
